import React, { PureComponent } from 'react';
import { getColorPrice } from '../../../helpers/Color';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  formatDataBidAsk,
  getDataFollowKeyByDot,
} from '../../../helpers/Common';
import Const from './Const';
import TextBlink from '../../../common/table/TextBlink';
import { formatPrice, formatTextFloat } from '../../../helpers/Text';
import { REDUCER_NAME } from '../reducer';

class BidAsk extends PureComponent {
  render() {
    const { item, itemKey: key, text, realtimeData } = this.props;
    const data = {
      ...item,
      ...realtimeData,
      tradingDate:
        realtimeData && realtimeData.bidAsk
          ? realtimeData.bidAsk.tradingDate
          : get(item, 'priceInfo.tradingDate') || item.tradingDate,
    };
    const className = getColorPrice(
      getDataFollowKeyByDot(data, key),
      getDataFollowKeyByDot(data, Const.index.REFERENCE_PRICE),
      getDataFollowKeyByDot(data, Const.index.CEILING_PRICE),
      getDataFollowKeyByDot(data, Const.index.FLOOR_PRICE),
      'text',
    );
    const bidAsk = getDataFollowKeyByDot(data, key);
    const bidAskVolume =
      Const.index.BEST_1_BID === key
        ? getDataFollowKeyByDot(data, Const.index.BEST_1_BID_VOLUME)
        : getDataFollowKeyByDot(data, Const.index.BEST_1_OFFER_VOLUME);
    const bidAskData = formatDataBidAsk(
      bidAsk,
      bidAskVolume,
      getDataFollowKeyByDot(data, Const.index.TRADING_DATE),
      false,
      get(data, 'priceInfo.marketStatus'),
      get(data, 'priceInfo.comGroupCode'),
    );

    return (
      <TextBlink
        keyObject={key}
        item={data}
        tradingDate="tradingDate"
        className={className}
      >
        {bidAskData || formatTextFloat(formatPrice(text), 2, true)}
      </TextBlink>
    );
  }
}

BidAsk.defaultProps = {};

const mapStateToProps = (state, { item }) => ({
  realtimeData: state[REDUCER_NAME].summaryBidAskRealtimeData[item.organCode],
});

export default connect(mapStateToProps)(BidAsk);
